/**
 * Organisations UI theme — taken as-is from the agreed prototype
 * (docs/engineering/ORG_UI_DESIGN_REVIEW.md, "Use the prototype's design and theme").
 * One place for the colours so the shell and the org pages cannot drift.
 */

export const T = {
  purple: '#7A3BD9',
  purpleHover: '#6A2FC4',
  purpleText: '#5B21B6',
  tint: '#F3EDFC',
  tintSoft: '#F7F2FE',
  tintBorder: '#DCCFF3',
  dark: '#1C1A22',
  ink: '#4A4653',
  muted: '#6B6775',
  faint: '#8C8796',
  border: '#ECE9F0',
  inputBorder: '#DDD8E4',
  page: '#FAF9FB',
  hover: '#F4F2F6',
  green: '#15803D', greenBg: '#EAF6EE',
  amber: '#B45309', amberBg: '#FDF3E4',
  red: '#B42318', redBg: '#FDECEA',
} as const

/** Tile colours for organisations — the same org always gets the same pair. */
const TILES: Array<[string, string]> = [
  ['#7A3BD9', '#fff'], ['#E3F3F0', '#0F766E'], ['#FCEFD9', '#A15C07'],
  ['#DDEBFB', '#1D4ED8'], ['#FBE3EC', '#9D174D'], ['#E9DDFB', '#5B21B6'],
]

export function orgTile(id: string, name: string): { initials: string; bg: string; fg: string } {
  let h = 0
  for (const ch of id) h = (h * 31 + ch.charCodeAt(0)) >>> 0
  const [bg, fg] = TILES[h % TILES.length]
  return { initials: initials(name), bg, fg }
}

export function initials(name: string): string {
  return (name || '').split(/[\s@._']+/).filter(Boolean).map(w => w[0]).slice(0, 2).join('').toUpperCase() || '?'
}

export type OrgRoleName = 'owner' | 'admin' | 'creator' | 'learner'

/** The one role word shown next to an organisation (the most senior one held). */
export function mainRole(roles: readonly OrgRoleName[]): string {
  const r = (['owner', 'admin', 'creator', 'learner'] as const).find(x => roles.includes(x)) ?? 'learner'
  return r[0].toUpperCase() + r.slice(1)
}
